<script lang="ts">
  import { fade } from "svelte/transition";
  import { guideChecklistPath } from "../../support/links";
  import { page } from "$app/stores";
  import Pager from "../../components/guides/pager.svelte";
  import Booklet from "../../components/guides/booklet.svelte";

  export let data;

  let index = -1;

  $: guides = data.guides;
  $: startId = $page.url.searchParams.get("start");
  $: start = guides.findIndex((g) => g.id == startId);
  $: activeGuide = guides[index];
</script>

<Pager bind:index {start}>
  {#each guides as guide (guide.id)}
    <Booklet
      tag="a"
      {guide}
      href={guideChecklistPath(guide)}
      style="flex: 0 0 420px; align-self: center;"
    />
  {/each}
</Pager>

<footer class="Note">
  {#if activeGuide}
    {#key activeGuide.id}
      <div class="InnerNote" transition:fade={{ duration: 150 }}>
        {@html activeGuide.description || activeGuide.title}
      </div>
    {/key}
  {/if}
</footer>

<style>
  .Note {
    font-size: 16px;
    flex: 0 0 140px;
    hyphens: auto;
    line-height: 1.4em;
    position: relative;
  }

  .InnerNote {
    bottom: auto;
    height: 100%;
    left: 0;
    mask-image: linear-gradient(0, transparent, black 24px, black calc(100% - 12px), transparent);
    overflow-y: auto;
    padding-block: max(24px, 2vh);
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
    position: absolute;
    text-align: center;
    top: auto;
    width: 100%;
  }

  .InnerNote :global(*:first-child) {
    margin-top: 0;
  }

  .InnerNote :global(:last-child) {
    margin-bottom: 0;
  }
</style>
